import request from '../utils/request';

/**
 * 用户统计数据API服务
 */
const userStatisticsApi = {
  /**
   * 获取用户概览统计数据
   * @param {Object} params - 请求参数对象
   * @param {string} params.timeRange - 时间范围类型：today-今日, last7days-近七日, last30days-近30天, month-月份, year-年份, custom-自定义
   * @param {string} params.startDate - 开始日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @param {string} params.endDate - 结束日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @param {string} params.year - 年份（month和year时间范围时使用）
   * @param {string} params.month - 月份（month时间范围时使用）
   * @returns {Promise} - 返回请求Promise
   */
  getUserOverview: (params = {}) => {
    console.log("params", params)
    return request({
      url: '/user-statistics/overview/range',
      method: 'get',
      params
    });
  },
  
  /**
   * 获取用户趋势统计数据
   * @param {Object} params - 请求参数对象
   * @param {string} params.timeRange - 时间范围类型：today-今日, last7days-近七日, last30days-近30天, month-月份, year-年份, custom-自定义
   * @param {string} params.startDate - 开始日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @param {string} params.endDate - 结束日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @param {string} params.year - 年份（month和year时间范围时使用）
   * @param {string} params.month - 月份（month时间范围时使用）
   * @returns {Promise} - 返回请求Promise
   */
  getUserTrend: (params = {}) => {
    return request({
      url: '/user-statistics/trend',
      method: 'get',
      params
    });
  },
  
  /**
   * 获取用户分布统计数据
   * @param {Object} params - 请求参数对象
   * @param {string} params.timeRange - 时间范围类型：today-今日, month-月份, year-年份, custom-自定义
   * @param {string} params.date - 统计日期（自定义时使用，格式：YYYY-MM-DD）
   * @param {string} params.year - 年份（month和year时间范围时使用）
   * @param {string} params.month - 月份（month时间范围时使用）
   * @returns {Promise} - 返回请求Promise
   */
  getUserDistribution: (params = {}) => {
    return request({
      url: '/user-statistics/distribution',
      method: 'get',
      params
    });
  }
};

export default userStatisticsApi; 